import { t } from 'i18next'
import { useState } from 'react'

import { PopoverInput } from '@ui/components/Popover'

import { NameDto } from '@model/NameDto'
import { ReferralMaterialPreviewUrls } from '@model/ReferralMaterialDto'

import { SetState } from '@global/types/SetState'

interface ReferralLandingPageDropdownProps {
  landingPageUrl: NameDto<string> | undefined
  setLandingPageUrl: SetState<NameDto<string> | undefined>
  shortenedReferralLink?: string
  setShortenedReferralLink: SetState<string | undefined>
  landingPageUrlsFromCategories?: ReferralMaterialPreviewUrls[]
  isLoadingLpUrlsFromCategories: boolean
  label?: string
  resetReferralLinks: () => void
}

export const ReferralLinkDropdown = ({
  landingPageUrl,
  setLandingPageUrl,
  shortenedReferralLink,
  setShortenedReferralLink,
  landingPageUrlsFromCategories,
  isLoadingLpUrlsFromCategories,
  label,
  resetReferralLinks,
}: ReferralLandingPageDropdownProps) => {
  const [selectedReferralMaterialUrls, setSelectedReferralMaterialUrls] =
    useState<ReferralMaterialPreviewUrls | null>(null)

  const getOptions = () => [
    ...(landingPageUrlsFromCategories
      ? landingPageUrlsFromCategories.map((url) => ({
          id: url.alias,
          name: url.alias,
        }))
      : []),
  ]

  const handleChange = (option: { id: string; name: string }) => {
    !!shortenedReferralLink && setShortenedReferralLink(undefined)

    const referralMaterialUrls = landingPageUrlsFromCategories?.find(
      (referralMaterialUrl) => referralMaterialUrl.alias === option.name
    )

    if (referralMaterialUrls?.urls.length === 1) {
      setLandingPageUrl(referralMaterialUrls.urls[0])
      setSelectedReferralMaterialUrls(referralMaterialUrls)
    } else if (referralMaterialUrls) {
      setLandingPageUrl(undefined)
      resetReferralLinks()
      setSelectedReferralMaterialUrls(referralMaterialUrls)
    }
  }

  return (
    <>
      <PopoverInput
        isWidthFixed
        value={selectedReferralMaterialUrls?.alias}
        disabled={isLoadingLpUrlsFromCategories}
        dropdownListVariant='compact'
        size='lg'
        label={label ? label : t('IB.Dashboard.ReferralLink.Select option')}
        options={getOptions()}
        onChange={handleChange}
      />
      {selectedReferralMaterialUrls && selectedReferralMaterialUrls.urls.length > 1 && (
        <PopoverInput
          size='lg'
          value={landingPageUrl?.id}
          disabled={isLoadingLpUrlsFromCategories}
          dropdownListVariant='compact'
          label={t('Referral Materials.Select target URL')}
          options={[...(selectedReferralMaterialUrls.urls ?? [])]}
          onChange={(url) => setLandingPageUrl(url)}
        />
      )}
    </>
  )
}
